import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutIndex from "./component/pages/about/AboutIndex";
import HomeIndex from "./component/pages/home/HomeIndex";
import Navbar from "./component/global/Navbar";
import Footer from "./component/global/Footer";
import ProductIndex from "./component/pages/product/Product";
import ServiceIndex from "./component/pages/services/ServiceIndex";
import ContactIndex from "./component/pages/contactUs/ContactIndex";
import ProductDetailsIndex from "./component/pages/product/ProductDetails";
import IndustriesIndex from "./component/pages/Industries/Industries";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomeIndex />} />
        <Route path="/about" element={<AboutIndex />} />
        <Route path="/product/:id" element={<ProductDetailsIndex />} />
        <Route path="/Products" element={<ProductIndex />} />
        <Route path="/services" element={<ServiceIndex />} />
        <Route path="/industries/:industryName" element={<IndustriesIndex />} />
        <Route path="/contact" element={<ContactIndex />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
